import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { HttpErrorService, SKIP_ERROR_INTERCEPTOR } from '../services/http-error.service';

/**
 * HTTP Error Interceptor
 *
 * Intercepta los errores HTTP globalmente.:
 * - Muestra ErrorDialog automáticamente para errores críticos
 * - Respeta skipInterceptor context para manejo manual
 * - No intercepta Blob responses (descarga de archivos)
 * - Maneja código 4043 (lista vacía) como caso especial
 * Casos donde NO se intercepta:
 * - Request con SKIP_ERROR_INTERCEPTOR context (autoguardado, upload)
 * - Blob responses (descarga de archivos - componente tiene más contexto)
 * - Código 4043 (lista vacía - no es error)
 */
export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorService = inject(HttpErrorService);
  // Verificar si debe skip el interceptor
  // Usado para autoguardado de drafts y upload de documentos
  if (req.context.get(SKIP_ERROR_INTERCEPTOR)) {
    return next(req); // No interceptar, dejar que componente maneje
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Caso especial: Blob responses (descarga de archivos)
      const isBlobRequest = req.responseType === 'blob';

      if (!isBlobRequest) {
        // Mostrar ErrorDialog automáticamente
        // El servicio ya verifica si es código 4043 (no muestra dialog)
        errorService.handleHttpError(error);
      }
      return throwError(() => error);
    })
  );
};
